"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = typeof window !== 'undefined' && typeof document !== 'undefined';
//# sourceMappingURL=is_browser.js.map